import numeral from 'numeral';
import moment from 'moment';
import { attributionTitle } from '../../config/filters';
import { getRangeFromDays } from '../../utils/dates';

export const config = {
  ATTRIBUTION_TITLE_PAGE_ID: 'attributionTitle',
  ATTRIBUTION_TITLE_FILTERS: attributionTitle
};

const getTitleType = titleType => {
  let type = '';
  if (titleType === 'movie') {
    type = 'Movie';
  } else if (titleType === 'series') {
    type = 'Show';
  }
  return type;
};

export const columns = [
  {
    Header: 'ID',
    accessor: 'contentId',
    className: 'tvt-tabular-data-table__attributiontitle-id'
  },
  {
    Header: 'Title',
    accessor: 'contentName',
    className: 'tvt-tabular-data-table__attributiontitle-title'
  },
  {
    Header: 'Content Type',
    accessor: 'contentType',
    className: 'tvt-tabular-data-table__attributiontitle-content_type',
    Cell: ({ row: { original }, cell: { value } }) => {
      return getTitleType(original.contentType);
    }
  },
  {
    Header: 'Release Date',
    accessor: 'releaseDate',
    className: 'tvt-tabular-data-table__attributiontitle-release_date',
    Cell: ({ row: { original }, cell: { value } }) =>
      moment(value).format('MM/DD/YYYY')
  },
  {
    Header: 'Originating Network/Studio',
    accessor: 'studioName',
    className: 'tvt-tabular-data-table__attributiontitle-studio',
    Cell: ({ row: { original }, cell: { value } }) => {
      let name = '';
      if (original.networkName) {
        name = original.networkName;
      }
      if (original.studioName) {
        name =
          name.length > 0
            ? `${name} / ${original.studioName}`
            : original.studioName;
      }
      return name;
    }
  },
  {
    Header: 'Platform',
    accessor: 'platformName',
    className: 'tvt-tabular-data-table__attributiontitle-platform'
  },
  {
    Header: 'Votes',
    accessor: 'voteCount',
    className: 'tvt-tabular-data-table__attributiontitle-votes',
    Cell: ({ row: { original }, cell: { value } }) => numeral(value).format(',')
  },
  {
    Header: '% Title Votes',
    accessor: 'titleVoteShare',
    className: 'tvt-tabular-data-table__attributiontitle-percent_title',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value).format('0.00%')
  },
  {
    Header: '% Platform Votes',
    accessor: 'platformVoteShare',
    className: 'tvt-tabular-data-table__attributiontitle-percent_platform',
    Cell: ({ row: { original }, cell: { value } }) =>
      numeral(value).format('0.00%')
  }
];

export const attributionTitleFilters = {
  content: [
    {
      id: 'title',
      label: 'Title(s)',
      tooltip: 'Title tooltip'
    },
    {
      id: 'date',
      label: 'Report Date',
      isToggle: true,
      options: [
        { value: null, label: 'All Time' },
        { value: getRangeFromDays(30).value, label: 'Last 30 days' },
        { value: getRangeFromDays(60).value, label: 'Last 60 days' },
        { value: getRangeFromDays(90).value, label: 'Last 90 days' },
        { value: -1, label: 'Custom', id: 'custom-date' }
      ]
    }
  ],
  demographic: [
    { id: 'age', label: 'Age Range' },
    { id: 'country', label: 'Region' },
    {
      id: 'gender',
      label: 'Gender',
      isToggle: true,
      options: [
        { value: null, label: 'All' },
        { value: 'female', label: 'Female' },
        { value: 'male', label: 'Male' }
      ]
    },
    {
      id: 'panel',
      label: 'Panel',
      isToggle: true,
      options: [
        { value: null, label: 'Total' },
        { value: 'Yes', label: 'Balanced' }
      ]
    }
  ]
};

export const defaultSorts = ['voteCount'];

export default { config, defaultSorts };
